// Change equipment type on type selector
// const typeOptionEls = [
//   ...document.querySelectorAll(".type-selector__item[data-type-slug]"),
// ];

// typeOptionEls.forEach((typeEl) => {
//   typeEl.addEventListener("click", () => {
//     const slug = typeEl.dataset.typeSlug;
//     FWP.facets.equipment_type.push(slug);
//     FWP.fetchData();
//     // remove any active types
//     const activeType = document.querySelector(".type-selector__item--active");
//     if (activeType) {
//       activeType.classList.remove("type-selector__item--active");
//     }
//     typeEl.classList.add("type-selector__item--active");
//   });
// });

const facetPagerEl = document.querySelector(
  ".archive-equipment__pagination-container"
);
const typeOptionSelector = document.querySelector(
  ".archive-equipment__type-selector-container"
);

document.addEventListener("facetwp-loaded", () => {
  // Disappear pager when there are no more pages
  if (FWP.settings.pager.page === FWP.settings.pager.total_pages) {
    facetPagerEl.remove();
  }

  // Disappear thumbnails when a type is selected
  if (FWP.facets.equipment_type.length && typeOptionSelector) {
    typeOptionSelector.remove();
  }
});
